import type { ThemeDefinition } from "./types";
import { DARKULA, hexToSrgb, hexToLinear } from "./palette";

export const darkula: ThemeDefinition = {
  label: "Darkula",
  className: "theme-darkula",
  bg: DARKULA.bg,
  text: DARKULA.fg,
  textMuted: DARKULA.fgMuted,
  accent: DARKULA.accent,
  glassRgb: DARKULA.glassRgb,
  border: DARKULA.border,
  borderHighlight: DARKULA.borderHighlight,
  separator: DARKULA.separator,
  selection: DARKULA.selection,
  selectionText: DARKULA.selectionText,
  gridColor: DARKULA.fg,
  noiseOpacity: DARKULA.noiseOpacity,
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.1), 0 10px 0px rgba(0,0,0,0.50)",
  gpuClear: hexToSrgb(DARKULA.bg),
  gpuGridLine: hexToLinear(DARKULA.fg),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear(DARKULA.accent),
  gpuAxisZ: hexToLinear(DARKULA.cyan),
  axisXColor: DARKULA.accent,
  axisZColor: DARKULA.cyan,
  font: '"JetBrains Mono", monospace',
  fontImport: 'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@300;400;500;600;700&display=swap',
};
